import React, { useState, useEffect } from 'react';
import { HelmetProvider } from 'react-helmet-async';
import { BrowserRouter as Router, Routes, Route, useLocation, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { CartProvider } from './context/CartContext';
import Header from './components/common/Header';
import Footer from './components/common/Footer';
import WhatsAppButton from './components/common/WhatsAppButton';
import { Link } from 'react-router-dom';
import LoadingScreen from './components/common/LoadingScreen';
import Home from './pages/Home';
import ProductDetail from './pages/ProductDetail';
import SeriesDetail from './pages/series-details/SeriesDetail';
import SeriesDetailRavor from './pages/series-details/SeriesDetailRavor';
import SeriesDetailVantor from './pages/series-details/SeriesDetailVantor';
import SeriesDetailTrailray from './pages/series-details/SeriesDetailTrailray';
import SeriesDetailHardRay from './pages/series-details/SeriesDetailHardRay';
import SeriesDetailVamok from './pages/series-details/SeriesDetailVamok';
import SeriesDetailKorak from './pages/series-details/SeriesDetailKorak';
import SeriesDetailAirok from './pages/series-details/SeriesDetailAirok';
import SeriesDetailNorza from './pages/series-details/SeriesDetailNorza';
import SeriesDetailTavano from './pages/series-details/SeriesDetailTavano';
import SeriesDetailTahona from './pages/series-details/SeriesDetailTahona'; // Tahona Series
import SeriesDetailMetmo from './pages/series-details/SeriesDetailMetmo'; // Metmo Series
import SeriesDetailTourray from './pages/series-details/SeriesDetailTourray';
import SeriesDetailArva from './pages/series-details/SeriesDetailArva';
import SeriesDetailKirana from './pages/series-details/SeriesDetailKirana';
import SeriesDetailSoreno from './pages/series-details/SeriesDetailSoreno';
import SeriesDetailTerrit from './pages/series-details/SeriesDetailTerrit';
import SeriesDetailZayn from './pages/series-details/SeriesDetailZayn';
import SeriesDetailRokua from './pages/series-details/SeriesDetailRokua';
import SeriesDetailYara from './pages/series-details/SeriesDetailYara';
import SeriesDetailArid from './pages/series-details/SeriesDetailArid';
import SeriesDetailNayta from './pages/series-details/SeriesDetailNayta';
import SeriesDetailNaytaKids from './pages/series-details/SeriesDetailNaytaKids';
import SeriesDetailYangaKids from './pages/series-details/SeriesDetailYangaKids';
import SeriesDetailTarok from './pages/series-details/SeriesDetailTarok';
import SeriesDetailDurok from './pages/series-details/SeriesDetailDurok';
import Success from './pages/Success';
import EventAttendance from './pages/EventAttendance';
import MaintenanceBooking from './pages/MaintenanceBooking';
import Giveaway from './pages/Giveaway';
import TotemCatalog from './pages/TotemCatalog';
import TotemSeriesDetail from './pages/TotemSeriesDetail';
import SeriesDetailTarokTotem from './pages/series-details/SeriesDetailTarokTotem';
import TuesdayRegistration from './pages/TuesdayRegistration';
import AnniversaryRegistration from './pages/AnniversaryRegistration';
import AguinaldoRegistration from './pages/AguinaldoRegistration';



// Admin Components
import AdminRoute from './components/admin/AdminRoute';
import AdminLayout from './components/admin/AdminLayout';
import Dashboard from './pages/admin/Dashboard';
import ProductList from './pages/admin/ProductList';
import ProductForm from './components/admin/ProductForm';
import AttendanceList from './pages/admin/AttendanceList';
import TuesdayAttendanceList from './pages/admin/TuesdayAttendanceList';
import MaintenanceList from './pages/admin/MaintenanceList';
import AnniversaryList from './pages/admin/AnniversaryList';
import AguinaldoList from './pages/admin/AguinaldoList';
import ChristmasBikesAdmin from './pages/admin/ChristmasBikesAdmin';
import ChristmasBikeDetail from './pages/ChristmasBikeDetail';
import NotFound from './pages/NotFound';
import LegalPage from './pages/LegalPage';
import LandingPage from './pages/LandingPage';
import BlogIndex from './pages/blog/BlogIndex';
import BlogPost from './pages/blog/BlogPost';
import landingPages from './content/landingPages.json';


// User Components
import PrivateRoute from './components/auth/PrivateRoute';
import UserProfile from './pages/UserProfile';

import ScrollToTop from './components/common/ScrollToTop';
import PageTitleUpdater from './components/common/PageTitleUpdater';
import Shop, { CategoryShop } from './pages/Shop';
import PhotoUpload from './pages/PhotoUpload';
import PhotoList from './pages/admin/PhotoList';

// The old search URL (/search?q=) now lives on the shop page
const SearchRedirect = () => {
  const { search } = useLocation();
  return <Navigate to={`/tienda${search}`} replace />;
};

// Move logic into a sub-component to use useLocation
const AppContent = ({ loading, isFading, handleLoadingComplete }) => {
  const location = useLocation();
  const isAdminPath = location.pathname.startsWith('/admin');
  const isTotemPath = location.pathname.startsWith('/totem');

  return (
    <div className="flex flex-col min-h-screen bg-white">
      {loading && (
        <LoadingScreen
          onComplete={handleLoadingComplete}
          isFading={isFading}
        />
      )}

      {!isTotemPath && <Header />}

      <div className={`flex-grow ${!isTotemPath ? 'pt-20' : ''}`}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/tienda" element={<Shop />} />
          <Route path="/accesorios" element={<Shop />} />
          <Route path="/catalogo" element={<Shop />} />
          <Route path="/ebikes" element={<Shop />} />
          <Route path="/bicicletas-analogas" element={<Shop />} />
          <Route path="/category/:categorySlug" element={<CategoryShop />} />
          <Route path="/bicicletas/:coleccionSlug" element={<Shop />} />
          <Route path="/serie/:serieId" element={<SeriesDetail />} />
          <Route path="/product/:id" element={<ProductDetail />} />
          <Route path="/series/ravor" element={<SeriesDetailRavor />} />
          <Route path="/series/vantor" element={<SeriesDetailVantor />} />
          <Route path="/series/trailray" element={<SeriesDetailTrailray />} />
          <Route path="/series/hardray" element={<SeriesDetailHardRay />} />
          <Route path="/series/vamok" element={<SeriesDetailVamok />} />
          <Route path="/series/korak" element={<SeriesDetailKorak />} />
          <Route path="/series/airok" element={<SeriesDetailAirok />} />
          <Route path="/series/norza" element={<SeriesDetailNorza />} />
          <Route path="/series/tavano" element={<SeriesDetailTavano />} />
          <Route path="/series/tahona" element={<SeriesDetailTahona />} />
          <Route path="/series/metmo" element={<SeriesDetailMetmo />} />
          <Route path="/series/tourray" element={<SeriesDetailTourray />} />
          <Route path="/series/arva" element={<SeriesDetailArva />} />
          <Route path="/series/kirana" element={<SeriesDetailKirana />} />
          <Route path="/series/soreno" element={<SeriesDetailSoreno />} />
          <Route path="/series/territ" element={<SeriesDetailTerrit />} />
          <Route path="/series/zayn" element={<SeriesDetailZayn />} />
          <Route path="/series/rokua" element={<SeriesDetailRokua />} />
          <Route path="/series/yara" element={<SeriesDetailYara />} />
          <Route path="/series/arid" element={<SeriesDetailArid />} />
          <Route path="/series/nayta" element={<SeriesDetailNayta />} />
          <Route path="/series/nayta-kids" element={<SeriesDetailNaytaKids />} />
          <Route path="/series/yanga-kids" element={<SeriesDetailYangaKids />} />
          <Route path="/series/tarok" element={<SeriesDetailTarok />} />
          <Route path="/tarok" element={<Navigate to="/series/tarok" replace />} />
          <Route path="/series/durok" element={<SeriesDetailDurok />} />
          <Route path="/durok" element={<Navigate to="/series/durok" replace />} />
          <Route path="/search" element={<SearchRedirect />} />
          <Route path="/gracias" element={<Success />} />
          <Route path="/compartir-fotos" element={<PhotoUpload />} />
          <Route path="/confirmar-asistencia" element={<EventAttendance />} />
          <Route path="/agendar-mantenimiento" element={<MaintenanceBooking />} />
          <Route path="/sorteo" element={<Giveaway />} />
          <Route path="/totem" element={<TotemCatalog />} />
          <Route path="/totem/series/tarok" element={<SeriesDetailTarokTotem />} />
          <Route path="/totem/series/:serieName" element={<TotemSeriesDetail />} />
          <Route path="/registro-martes" element={<TuesdayRegistration />} />
          <Route path="/registro-aniversario" element={<AnniversaryRegistration />} />
          <Route path="/registro-aniversario-invitado" element={<AnniversaryRegistration isGuest={true} />} />
          <Route path="/registro-aguinaldo" element={<AguinaldoRegistration />} />
          <Route path="/aguinaldo-navideno" element={<AguinaldoRegistration />} />
          <Route path="/aguinaldo" element={<AguinaldoRegistration />} />
          <Route path="/navidad" element={<Shop />} />
          <Route path="/bicicletas-navidad" element={<Shop />} />
          <Route path="/navidad/:slug" element={<ChristmasBikeDetail />} />
          <Route path="/privacidad" element={<LegalPage page="privacidad" />} />
          <Route path="/cookies" element={<LegalPage page="cookies" />} />
          {Object.keys(landingPages).map((landingPath) => (
            <Route key={landingPath} path={landingPath} element={<LandingPage key={landingPath} path={landingPath} />} />
          ))}
          <Route path="/blog" element={<BlogIndex />} />
          <Route path="/blog/:slug" element={<BlogPost />} />




          {/* Admin Routes */}
          <Route element={<AdminRoute />}>
            <Route path="/admin" element={<AdminLayout />}>
              <Route index element={<Dashboard />} />
              <Route path="bikes" element={<ProductList type="bikes" />} />
              <Route path="bikes/new" element={<ProductForm type="bikes" />} />
              <Route path="bikes/edit/:id" element={<ProductForm type="bikes" />} />

              <Route path="accessories" element={<ProductList type="accessories" />} />
              <Route path="accessories/new" element={<ProductForm type="accessories" />} />
              <Route path="accessories/edit/:id" element={<ProductForm type="accessories" />} />
              <Route path="attendance" element={<AttendanceList />} />
              <Route path="tuesday-attendance" element={<TuesdayAttendanceList />} />
              <Route path="maintenance" element={<MaintenanceList />} />
              <Route path="anniversary" element={<AnniversaryList />} />
              <Route path="aguinaldo" element={<AguinaldoList />} />
              <Route path="navidad" element={<ChristmasBikesAdmin />} />
              <Route path="fotos" element={<PhotoList />} />
              <Route path="products" element={<ProductList />} />
            </Route>
          </Route>

          {/* User Routes */}
          <Route element={<PrivateRoute />}>
            <Route path="/profile" element={<UserProfile />} />
          </Route>

          <Route path="*" element={<NotFound />} />
        </Routes>
      </div>

      {/* Hide footer and whatsapp on admin routes */}
      {!isAdminPath && !isTotemPath && <Footer />}
      {!isAdminPath && !isTotemPath && <WhatsAppButton />}
    </div>
  );
};

// The intro animation plays on the first visit and again once a week, not on every page load
const INTRO_KEY = 'proomtb-intro-seen';
const INTRO_EVERY_MS = 7 * 24 * 60 * 60 * 1000;

const shouldPlayIntro = () => {
  try {
    const seen = Number(localStorage.getItem(INTRO_KEY));
    return !(seen && Date.now() - seen < INTRO_EVERY_MS);
  } catch (e) {
    return true; // storage blocked: play it
  }
};

function App() {
  const [loading, setLoading] = useState(shouldPlayIntro);
  const [isFading, setIsFading] = useState(false);

  useEffect(() => {
    if (!loading) return;
    try { localStorage.setItem(INTRO_KEY, String(Date.now())); } catch (e) { /* storage blocked */ }
  }, [loading]);

  const handleLoadingComplete = () => {
    setIsFading(true);
    setTimeout(() => {
      setLoading(false);
    }, 700);
  };

  return (
    <HelmetProvider>
      <Router>
        <PageTitleUpdater />
        <ScrollToTop />
        <AuthProvider>
          <CartProvider>
            <AppContent
              loading={loading}
              isFading={isFading}
              handleLoadingComplete={handleLoadingComplete}
            />
          </CartProvider>
        </AuthProvider>
      </Router>
    </HelmetProvider>
  );
}

export default App;
